module.exports = __webpack_public_path__ + "img/Innen22.4bf5a56a.jpg";